module.exports = require("core-js/library/fn/symbol/iterator");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/symbol/iterator.js
// module id = 212
// module chunks = 35783957827783 52252321336229